import React, { Component } from 'react';
import {setAndGetAttributes, bindScmBlurHandler} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class TextInput extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = bindScmBlurHandler(this.props, setAndGetAttributes(this.props));
    
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
        />
      </Wrp>        
    );
  }
}

TextInput.defaultProps = {
  isMandatory:false,
  isEvent:false,
  className: 'form-control',
}

export default TextInput;